<app-header (menuClick)="openSidebar()"></app-header>

<app-sidebar [open]="sidebarOpen" (close)="closeSidebar()">
</app-sidebar>

<!-- Location status banners -->
<div class="location-banner location-banner--denied" *ngIf="locationStatus === 'denied'">
  <span>Omogući pristup lokaciji u postavkama preglednika kako bi audio vodič radio ispravno.</span>
</div>

<div class="location-banner location-banner--warning" *ngIf="locationStatus === 'unavailable'">
  <span>Lokacija nije dostupna. Provjeri je li GPS uključen.</span>
</div>

<div class="location-banner location-banner--warning" *ngIf="locationStatus === 'timeout'">
  <span>GPS signal nije pronađen. Pokušaj se pomaknuti na otvoreno.</span>
</div>

<div class="location-banner location-banner--waiting" *ngIf="locationStatus === 'waiting'">
  <span>Tražim tvoju lokaciju…</span>
</div>

<div class="location-banner location-banner--accuracy" *ngIf="locationStatus === 'ok' && locationAccuracyLow">
  <span>Slab GPS signal — automatsko otvaranje točaka možda neće raditi.</span>
</div>

<div class="map-container">
  <div id="map"></div>
</div>

<div class="bottom-sheet" [class.open]="activePoi">

  <div class="sheet-header">

    <div class="sheet-top-row">
      <span class="eyebrow">POSLUŠAJ</span>

      <button class="close" (click)="closePoi()" aria-label="Zatvori">
        <img src="assets/icons/x.png" style="height: 24px; width: 24px;" alt="Close" />
      </button>
    </div>

    <span style="font-size: 20px; font-weight: 600;">{{ activePoi?.title }}</span>
  </div>


  <div class="audio-list">

    <div class="audio-item" *ngFor="let track of visibleTracks">

      <img src="assets/icons/sound.png" style="width: 20px; height: 20px;" alt="Sound" />

      <span class="audio-title">
        {{ track.title }}
      </span>

      <button class="audio-btn play" (click)="togglePlay(track)" aria-label="Play / Pause">
        <ng-container *ngIf="currentTrack?.id === track.id && isPlaying">
          ⏸
        </ng-container>
        <ng-container *ngIf="currentTrack?.id !== track.id || !isPlaying">
          ▶
        </ng-container>
      </button>

      <button class="audio-btn restart" *ngIf="currentTrack?.id === track.id" (click)="startOver(track)"
        aria-label="Restart">
        ↺
      </button>
    </div>

  </div>
</div>
